const Profile = {

    // FIELDS
    "name": "Name",
    "staff_id": "Staff ID",
    "mobile": "Mobile Number",
    "email": "Email",
    "email_address": "Email Address",
    "department": "Department",
    "assigned_departments": "Assigned Departments",
    "designation": "Designation",
    "role": "Role",
    "profile": "Profile Photo",

    "old_password": "Old Password",
    "new_password": "New Password",
    "confirm_password": "Confirm Password",

    // PAGE HEADER
    "profile": "Profile",
    "password": "Password",
    "change_password": "Change Password",
    "professional_information": "Professional Information",
    "additional_information": "Additional Information",
    "personal_information": "Personal Information",
    "contact_information": "Contact Information",
    "profile_photo": "Profile Photo",

    // TOAST
    "success_changed": "Changed Successfully",

    // ERROR
    "error_name": "Enter Name",
    "error_staff_id": "Enter Staff ID",
    "error_mobile": "Enter Mobile Number",
    "error_invalid_mobile": "Invalid Mobile Number",
    "error_email": "Enter Email",
    "error_email_invalid": "Enter Valid Email",
    "error_department": "Select Department",
    "error_designation": "Select Designation",
    "error_profile_photo_type": "Profile photo must be JPG, JPEG, or PNG format",

    "error_old_password": "Enter Old Password",
    "error_new_password": "Enter New Password",
    "error_confirm_password": "Enter Confirm Password",
    "error_password_match": "Confirm Password doesn't match",

}

export default Profile;